/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContactInfoDto
 */
export interface UpdateContactInfoDto {
    /**
     * User input location street name
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    street?: string;
    /**
     * User input location building number
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    buildingNumber?: string;
    /**
     * Geocoding administrative area 3 (area)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea3?: string;
    /**
     * Geocoding administrative area 3 code (area)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea3Code?: string;
    /**
     * Geocoding administrative area 2 (city)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea2?: string;
    /**
     * Geocoding administrative area 2 code (city)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea2Code?: string;
    /**
     * Geocoding administrative area 1 (state/province/governorate)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea1?: string;
    /**
     * Geocoding administrative area 1 code (state/province/governorate)
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    adminArea1Code?: string;
    /**
     * Geocoding Location country
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    country?: string;
    /**
     * Geocoding Location country ISO code
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    countryCode?: string;
    /**
     * Geocoding formatted address
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    formattedAddress?: string;
    /**
     * Postal/ZIP code
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    postalCode?: string;
    /**
     * Location geo latitude
     * @type {number}
     * @memberof UpdateContactInfoDto
     */
    latitude?: number;
    /**
     * Location geo longitude
     * @type {number}
     * @memberof UpdateContactInfoDto
     */
    longitude?: number;
    /**
     * Location navigation directions and remarks
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    navDirections?: string;
    /**
     * Location phone number
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    phoneNumber?: string;
    /**
     * Location email address
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    email?: string;
    /**
     * Geocoding language
     * @type {string}
     * @memberof UpdateContactInfoDto
     */
    geocodingLanguage?: string;
}

/**
 * Check if a given object implements the UpdateContactInfoDto interface.
 */
export function instanceOfUpdateContactInfoDto(value: object): value is UpdateContactInfoDto {
    return true;
}

export function UpdateContactInfoDtoFromJSON(json: any): UpdateContactInfoDto {
    return UpdateContactInfoDtoFromJSONTyped(json, false);
}

export function UpdateContactInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'buildingNumber': json['buildingNumber'] == null ? undefined : json['buildingNumber'],
        'adminArea3': json['adminArea3'] == null ? undefined : json['adminArea3'],
        'adminArea3Code': json['adminArea3Code'] == null ? undefined : json['adminArea3Code'],
        'adminArea2': json['adminArea2'] == null ? undefined : json['adminArea2'],
        'adminArea2Code': json['adminArea2Code'] == null ? undefined : json['adminArea2Code'],
        'adminArea1': json['adminArea1'] == null ? undefined : json['adminArea1'],
        'adminArea1Code': json['adminArea1Code'] == null ? undefined : json['adminArea1Code'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'navDirections': json['navDirections'] == null ? undefined : json['navDirections'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'email': json['email'] == null ? undefined : json['email'],
        'geocodingLanguage': json['geocodingLanguage'] == null ? undefined : json['geocodingLanguage'],
    };
}

export function UpdateContactInfoDtoToJSON(value?: UpdateContactInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'buildingNumber': value['buildingNumber'],
        'adminArea3': value['adminArea3'],
        'adminArea3Code': value['adminArea3Code'],
        'adminArea2': value['adminArea2'],
        'adminArea2Code': value['adminArea2Code'],
        'adminArea1': value['adminArea1'],
        'adminArea1Code': value['adminArea1Code'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'formattedAddress': value['formattedAddress'],
        'postalCode': value['postalCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'navDirections': value['navDirections'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'geocodingLanguage': value['geocodingLanguage'],
    };
}

